import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
export var ButtonDialog = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { className: "button-ribbon" },
        React.createElement(ButtonPrimary, { onClick: onClick },
            React.createElement("div", { className: IdStyles.TextBoldAccent },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.confirm })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/ButtonDialog.tsx
// module id = 502
// module chunks = 3